
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","viewBox":"0 0 18 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.9655 2.32249C17.3018 2.61424 16.593 2.81299 15.8468 2.90374C16.6073 2.44549 17.1922 1.72324 17.469 0.861494C16.7558 1.27774 15.9653 1.58074 15.1238 1.74949C14.4518 1.03024 13.494 0.580244 12.4305 0.580244C10.3927 0.580244 8.7405 2.23249 8.7405 4.26799C8.7405 4.56049 8.77425 4.84174 8.83575 5.11099C5.76825 4.96624 3.0495 3.49324 1.23 1.26649C0.90975 1.80799 0.7305 2.43724 0.7305 3.12274C0.7305 4.40524 1.383 5.53249 2.3715 6.19474C1.76625 6.17524 1.197 6.00874 0.7005 5.73274V5.77849C0.7005 7.56724 1.97025 9.05899 3.66 9.39874C3.35025 9.48199 3.02325 9.52699 2.688 9.52699C2.4525 9.52699 2.22675 9.50449 2.001 9.46249C2.47425 10.9272 3.83475 11.9952 5.454 12.0252C4.194 13.0145 2.59725 13.604 0.8775 13.604C0.585 13.604 0.29325 13.5867 0 13.5537C1.64175 14.5992 3.576 15.2105 5.66775 15.2105C12.4583 15.2105 16.167 9.58849 16.167 4.72099C16.167 4.56424 16.167 4.40599 16.1558 4.24849C16.8765 3.73174 17.5057 3.07849 18.0007 2.33749L17.9655 2.32249Z","fill":"currentColor"}})])
          )
        }
      }
    